(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('GlobalMessageNotificationController', GlobalMessageNotificationController);

    GlobalMessageNotificationController.$inject = ['GlobalMessage', 'GlobalMessageViewed', 'CoreService', '$interval',
        'Principal'];

    function GlobalMessageNotificationController(GlobalMessage, GlobalMessageViewed, CoreService, $interval,
                                                 Principal) {
        var vm = this;

        vm.globalMessages = [];
        vm.close = close;
        vm.init = init;

        Principal.identity().then(function (account) {
            $interval(init, 30000);
        });

        function init() {
            var corporation = CoreService.getCorporation();

            if (corporation) {
                GlobalMessage.byCorporation({id: corporation.id}, function (result) {
                    vm.globalMessages = result;
                })
            }
        }

        function close(id) {
            GlobalMessageViewed.save({globalMessage: {id: id}}, function () {
                init();
            })
        }
    }
})();
